import React from 'react';

import PrimerDesigner from '../../components/results/PrimerDesigner';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export default function PrimerDesignPage() {
  const navigate = useNavigate();
  return (
<div>
      <Button 
        icon={<ArrowLeftOutlined />} 
        onClick={() => navigate('/cloning')}
        style={{ marginBottom: 16 }}
      >
        返回分子克隆
      </Button>
      <PrimerDesigner />
</div>
  );
}
